import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {repoAppBuilder} from '@github-ui/repo-app-builder'
import type {RepoAgentsPayload} from '../types/repo-agents-payload'

/**
 * Landing page route configuration.
 *
 * Defined as a builder-parameterized factory so tests and the repo app can create the
 * route with their respective builders.
 */
export function buildRepoAgentsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('repoAgentsRoute', {
    path: '/:owner/:repo/agents',
    queries: [mainQuery<RepoAgentsPayload>()],
  })
}

/**
 * Repo-bound route config imported by components that read this route's query data.
 */
export const repoAgentsRoute = buildRepoAgentsRoute(repoAppBuilder)
